import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { z } from 'zod/v4';

const MONGO_ID_REGEX = /^[0-9a-f]{24}$/;

// `driverName` only pre-labels the filter chip; filtering is driven by `driverId`. An invalid
// driverId degrades to undefined instead of failing the route, so a malformed shared link still
// loads the unfiltered list. `create` opens the order creation drawer on mount (e.g. the sidebar
// "New order" action) — the page strips it from the URL once consumed.
const ordersSearchSchema = z.object({
  create: z.boolean().optional().catch(undefined),
  driverId: z.string().regex(MONGO_ID_REGEX).optional().catch(undefined),
  driverName: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/orders/')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('orders:list')) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/orders/pages/orders-page')),
  validateSearch: (search) => ordersSearchSchema.parse(search),
});
